import { render, staticRenderFns } from "./ModelCompare.vue?vue&type=template&id=0dff0e08&scoped=true"
import script from "./ModelCompare.vue?vue&type=script&lang=js"
export * from "./ModelCompare.vue?vue&type=script&lang=js"
import style0 from "./ModelCompare.vue?vue&type=style&index=0&id=0dff0e08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dff0e08",
  null
  
)

export default component.exports